import axios from 'axios'
export default {
  getDefaultCategories: (page, pagination = false, filters = {}) =>
    axios.get('/default_category_offices/without_custom_categories', {
      params: { page: page, pagination: pagination, ...filters }
    }),

  getCustomCategories: (page, pagination = false, filters = {}) =>
    axios.get('/custom_categories', {
      params: { page: page, pagination: pagination, ...filters }
    }),

  getDefaultCategoriesOffice: (page, pagination = false, filters = {}) =>
    axios.get('/default_category_offices', {
      params: { page: page, pagination: pagination, ...filters }
    }),
    getLastUsedUserCategories: (userId, page, pagination = false, filters = {}) =>
    axios.get(`/users/${userId}/last_categories_used`, {
      params: { page: page, pagination: pagination, ...filters }
    }),

  // createCustomSubcategory: (categoryId, data) =>
  //   axios.post(`/default_categories/${categoryId}/custom_categories`, data),
  updateCustomSubcategory: (id, data) =>
    axios.put(`/custom_categories/${id}`, data),
  deleteCustomSubcategory: id => axios.delete(`/custom_categories/${id}`),
  updateDefaultCategory: (id, data) =>
    axios.put(`/default_category_offices/${id}`, data),

  /* Endpoints nuevos */
  createDefaultCategoryOffice: (defaultCategory) => {
    return axios.post(`/default_category_offices`, defaultCategory)
  },

  createCustomSubcategory: (defaultCategoryId, customCategory) =>
    axios.post(`/default_category_offices/${defaultCategoryId}/custom_categories`, customCategory),

  getDefaultCategoryImagesAndColors: (page, pagination = false, filters = {}) => {
    axios.get('/default_category_offices/images_and_colors', { params: { page: page, pagination: pagination, ...filters } })
  },

  putDefaultCategoryOffice: (defaultCategoryId, defaultCategoryData) => {
    axios.put(`/default_category_offices/${defaultCategoryId}`, defaultCategoryData)
  },
  deleteDefaultCategoryOffice: (defaultCategoryOfficeId) => {
    axios.delete(`/default_category_offices/${defaultCategoryOfficeId}`)
  }
}
